import { GameStatisticsContentRowProps } from './props';
import styles from './styles.module.scss';

export default function GameStatisticsContentRow({
  title,
  isLoading,
  value,
}: GameStatisticsContentRowProps) {
  if (isLoading) {
    return (
      <div className={styles.row}>
        <div className={styles.skeleton__value} />
        <div className={styles.skeleton__value} />
      </div>
    );
  }

  return (
    <div className={styles.row}>
      {title}
      <div
        className={`${styles.row__value} ${!value ? styles['row__value--empty'] : ''}`}
      >
        {value ?? '--'}
      </div>
    </div>
  );
}
